module.exports = __webpack_public_path__ + "img/3-1.4b3d7d08.jpg";